import axios from 'axios';
import KeycloakService from './KeycloakService';

const HttpMethods = {
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE',
  PUT: 'PUT',
};

const callsMade = [];

const filterHttpCalls = (filterItem) => {
  return callsMade.findIndex((reqItem) => {
    if (filterItem.data) {
      const one = filterItem.data
        ? typeof filterItem.data === 'string'
          ? filterItem.data.replace(/\\/g, '')
          : JSON.stringify(filterItem.data).replace(/\\/g, '')
        : '';
      const two = JSON.stringify(reqItem.data);
      if (typeof one === typeof two && one == two) {
        if (
          reqItem.url === filterItem.url &&
          reqItem.method === filterItem.method
        ) {
          return true;
        }
      }
    } else {
      return (
        reqItem.url === filterItem.url &&
        reqItem.data === filterItem.data &&
        reqItem.method === filterItem.method
      );
    }
  });
};

const _axios = axios.create();

const configure = () => {
  _axios.interceptors.request.use((config) => {
    if (KeycloakService.isLoggedIn()) {
      const tokenCallback = () => {
        sessionStorage.setItem(
          process.env.REACT_APP_TOKEN_REFERENCE || 'bsheets-app-token',
          KeycloakService.getToken() || 'no-token',
        );

        const filteredRequest = filterHttpCalls(config);
        if (filteredRequest !== -1) {
          const controller = new AbortController();
          controller.abort('Redundant call aborted');
          return {
            ...config,
            signal: controller.signal,
          };
        }
        // if (!((config.url.includes(`/users/`) || config.url.includes('/workflow/')) && config.method === "get")) {
        //   callsMade.push({
        //     url: config.url || "",
        //     method: config.method || "",
        //     data: config.data,
        //   });
        // }

        if (config && config.headers) {
          config.headers.Authorization = `Bearer ${KeycloakService.getToken()}`;
          return Promise.resolve(config);
        }
      };
      return KeycloakService.updateToken(tokenCallback);
    }
  });

  _axios.interceptors.response.use((response) => {
    if (response.status === 401) {
      KeycloakService.doLogout();
    }

    const filteredRequest = filterHttpCalls(response.config);
    if (filteredRequest !== -1) {
      callsMade.splice(filteredRequest, 1);
    }
    return response;
  });
};

const getAxiosClient = () => _axios;

const HttpService = {
  HttpMethods,
  configure,
  getAxiosClient,
};

export default HttpService;
